import axios from "axios";
import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { environment } from "../environment";
import { apiS } from "./api-base"
import { Base64Decoder, getESGReqHeader } from "./tool-service";


export const downloadFile=(data,fileName)=>{
    let blob = new Blob([Base64Decoder(data)]);
    const reader = new FileReader();
    reader.onloadend = function () {
        // if (window.navigator.msSaveOrOpenBlob) { //IE要使用 msSaveBlob
        //     window.navigator.msSaveBlob(data, fileName)
        // }
        // else {
            const file = new File([blob], fileName);
            const url = window.URL.createObjectURL(file);
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
        // }
    }
    reader.readAsText(blob);
  }



//上傳檔案 f0000201
export const uploadMultipartFile= async (formData) => { 
    return await apiS({ url: `/${getTxtIdMapperPath("F0000201")}`, method: 'post', data: formData })
}

//下載檔案 fileId
export const downloadMultipartFile= async (reqBody,responseType="blob") => { 
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0000202'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F0000202")}`, method: 'post', data: ReqBody,responseType:responseType },false,true)
}

//下載檔案 報告書專用
export const downloadMultipartFileReport= async (reqBody,responseType="blob") => { 
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0000202'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F0000202")}/report`, method: 'post', data: ReqBody,responseType:responseType },false,true)
}

//下載檔案 報告書專用
export const downloadMultipartFileWord= async (reqBody,responseType="blob") => { 
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0000202'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F0000202")}/toWord`, method: 'post', data: ReqBody,responseType:responseType },false,true)
}

  /***
   * 給 jpg png 下載圖片專用
   * 
  */
  export const axios_getFileImgBinaryData = async (fileId,type="ori") => {
    let filePath =`?fileId=${fileId}&type=${type}` 
    return await apiS({ url: `/${getTxtIdMapperPath("F0000203")}${filePath}`, method: 'GET',responseType:'blob'},false,true)
}

//刪除檔案 fileId
export const deleteMultipartFile= async (reqBody) => { 
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0000204'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F0000204")}`, method: 'post', data: ReqBody },false,true)
}

export const fetchImageUrl = async (options = {},isPdf=false)=> {    
    const baseUrl = options.baseUrl || `${environment.apiUrl}${options.path}`;
    const header1 = options.authToken || sessionStorage?.getItem('id_token');
    const header2 = options.accessToken || sessionStorage?.getItem('access_token');
  
    try {
        const response = await axios.get(baseUrl, {
            responseType: 'blob',
            headers: {
                'id-token':header1,
                Authorization: `Bearer ${header2}`
            }
        });
        if(isPdf){
            const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
            const url = URL.createObjectURL(pdfBlob);
            // window.open(url, '_blank');
            return url;
        }else{
            return URL.createObjectURL(response.data);
        }
    } catch (error) {
        console.error('Image fetch error:', error);
        return '';
    }
  }



  